// extracted by mini-css-extract-plugin
export default {"container":"ReportDisplayColumnLayout_container__-P6X7","displayRows":"ReportDisplayColumnLayout_displayRows__AykJb"};